export const CREATE_WATCHLIST_RECORD = "CREATE_WATCHLIST_RECORD"
export const DELETE_WATCHLIST_RECORD = "DELETE_WATCHLIST_RECORD"
export const KIT_INC_VIEWS = "KIT_INC_VIEWS"
export const GET_SIMILAR = "GET_SIMILAR"
export const KIT_CURRENCY = "KIT_CURRENCY"
export const ADD_QUESTION = "ADD_QUESTION"
export const ADD_ANSWER = "ADD_ANSWER"
export const GET_KIT_QA = "GET_KIT_QA"
export const KIT_REGISTER_VIEWER= "KIT_REGISTER_VIEWER"